import React, { useState } from 'react';
import { Search, Download, X } from 'lucide-react';
import useCertificationManagementStore from '@/stores/AdminStore/CertificationManagementStore';
import './LearnerProgress.css';

const LearnerProgress: React.FC = () => {
  const { learnerProgress } = useCertificationManagementStore();

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [teamFilter, setTeamFilter] = useState('all');

  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'certified':
        return 'admin-certifi-status-certified';
      case 'in progress':
        return 'admin-certifi-status-progress';
      case 'not started':
        return 'admin-certifi-status-not-started';
      default:
        return '';
    }
  };

  return (
    <div className="admin-certifi-learner-progress">
      <div className="admin-certifi-progress-header">
        <div className="admin-certifi-progress-filters">
          <div className="admin-certifi-progress-search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Search & Select Certificate"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select
            className="admin-certifi-progress-filter-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All status</option>
            <option value="certified">Certified</option>
            <option value="in-progress">In Progress</option>
            <option value="not-started">Not Started</option>
          </select>

          <select
            className="admin-certifi-progress-filter-select"
            value={teamFilter}
            onChange={(e) => setTeamFilter(e.target.value)}
          >
            <option value="all">All teams</option>
            <option value="engineering">Engineering</option>
            <option value="marketing">Marketing</option>
            <option value="sales">Sales</option>
          </select>
        </div>
      </div>

      <div className="admin-certifi-progress-table-container">
        <table className="admin-certifi-progress-table">
          <thead>
            <tr>
              <th>Learner</th>
              <th>Team / Role</th>
              <th>Progress</th>
              <th>Status</th>
              <th>Certified Date</th>
              <th>Expiry Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {learnerProgress?.map((learner) => (
              <tr key={learner.id}>
                <td>
                  <div className="admin-certifi-learner-name">{learner.name}</div>
                </td>
                <td>
                  <div className="admin-certifi-learner-info">
                    <div className="admin-certifi-learner-team">{learner.team}</div>
                    <div className="admin-certifi-learner-role">{learner.role}</div>
                  </div>
                </td>
                <td>
                  <div className="admin-certifi-progress-cell">
                    <div className="admin-certifi-progress-bar-container">
                      <div className="admin-certifi-progress-bar-fill" style={{ width: `${learner.progress}%` }} />
                    </div>
                    <span className="admin-certifi-progress-text">
                      {learner.progress}%
                      <br />
                      <small>
                        {learner.completed}/{learner.total} completed
                      </small>
                    </span>
                  </div>
                </td>
                <td>
                  <span className={`admin-certifi-status-badge ${getStatusBadgeClass(learner.status)}`}>
                    {learner.status}
                  </span>
                </td>
                <td>{learner.certifiedDate || '-'}</td>
                <td>{learner.expiryDate || '-'}</td>
                <td>
                  <div className="admin-certifi-action-icons">
                    <button className="admin-certifi-icon-btn" title="Remove">
                      <X size={16} />
                    </button>
                    <button className="admin-certifi-icon-btn" title="Download">
                      <Download size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LearnerProgress;
